import axios from 'axios';
import { verifyEnvUrl } from '../../util/verifyEnvUrl';

const PROD_SPARKS_URL = 'https://us-central1-acordo-fechado-dev.cloudfunctions.net/sparkApiFunction';
const DEV_SPARKS_URL  = 'https://us-central1-acordo-fechado-dev.cloudfunctions.net/sparkApiFunction';

const sparksApi = axios.create( {
	baseURL: verifyEnvUrl( PROD_SPARKS_URL, DEV_SPARKS_URL ),
} );

sparksApi.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );

export default sparksApi;
